/**
 * Custom Health Check API - Renderer Process
 * Manages custom health checks registered by extensions
 */
export function createCustomCheckApi(registry, api) {
    return {
        /**
         * Register a custom health check
         * The check function runs in the renderer process
         */
        register: (healthCheck) => {
            registry.register(healthCheck);
        },
        /**
         * Unregister a custom health check
         */
        unregister: (checkId) => {
            registry.unregisterHealthCheck(checkId);
        },
        /**
         * Run a single custom health check
         * @param checkId - ID of the check to run
         * @param force - Force execution even if cached
         */
        run: async (checkId, force) => {
            return registry.runHealthCheck(checkId, api, force);
        },
        /**
         * Run all custom checks matching a trigger
         * @param trigger - Trigger type (e.g., 'mod-activated', 'game-launched')
         */
        runByTrigger: async (trigger) => {
            return registry.runChecksByTrigger(trigger, api);
        },
        /**
         * Get all registered custom checks
         */
        getAll: () => {
            return registry.getAll();
        },
    };
}
